import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * Sidebar revamp toggle state (2026 white-sidebar redesign).
 * Kept isolated from the legacy `toggleBodyClass()` (src/index.html) /
 * `.sidebar-active` system so the whole feature can be removed by deleting
 * this file and its two call sites in main.component.ts/html.
 */
@Injectable({ providedIn: 'root' })
export class SidebarToggleService {
  private collapsedSource = new BehaviorSubject<boolean>(false);
  collapsed$ = this.collapsedSource.asObservable();

  get collapsed(): boolean {
    return this.collapsedSource.value;
  }

  toggle(): void {
    this.collapsedSource.next(!this.collapsedSource.value);
  }

  // Explicit (idempotent) close — used to auto-hide the mobile off-canvas
  // menu after navigating, without risking accidentally opening it.
  close(): void {
    if (this.collapsedSource.value) {
      this.collapsedSource.next(false);
    }
  }
}
